import React from "react";
import BackButton from "src/components/BackButton";

interface TabProps {
  setTab: (tab: number) => void;
  tab: number;
}

function RestaurantTab({ setTab, tab }: TabProps) {
  return (
    <div className="w-full bg-white border border-amber-200 rounded-xl shadow-sm p-2 md:p-3 flex items-center gap-2 md:gap-3 overflow-x-auto">
      <BackButton />
      <div
        onClick={() => setTab(0)}
        className={`py-2 px-3 text-xs sm:text-sm md:text-base whitespace-nowrap cursor-pointer ${
          tab === 0
            ? "border-b-4 border-pr-primary text-pr-primary"
            : "text-gray-500"
        }`}
      >
        Restaurant Details
      </div>
      <div
        onClick={() => setTab(1)}
        className={`py-2 px-3 text-xs sm:text-sm md:text-base whitespace-nowrap cursor-pointer ${
          tab === 1
            ? "border-b-4 border-pr-primary text-pr-primary"
            : "text-gray-500"
        }`}
      >
        Order History
      </div>

      <div
        onClick={() => setTab(2)}
        className={`py-2 px-3 text-xs sm:text-sm md:text-base whitespace-nowrap cursor-pointer ${
          tab === 2
            ? "border-b-4 border-pr-primary text-pr-primary"
            : "text-gray-500"
        }`}
      >
        Bank Details
      </div>

      <div
        onClick={() => setTab(3)}
        className={`py-2 px-3 text-xs sm:text-sm md:text-base whitespace-nowrap cursor-pointer ${
          tab === 3
            ? "border-b-4 border-pr-primary text-pr-primary"
            : "text-gray-500"
        }`}
      >
        Wallet History
      </div>

      <button
        className={`py-2 px-3 text-xs sm:text-sm md:text-base whitespace-nowrap ${
          tab === 4
            ? "border-b-4 border-pr-primary text-pr-primary"
            : "text-gray-500"
        }`}
        onClick={() => setTab(4)}
      >
        Transaction History
      </button>
    </div>
  );
}

export default RestaurantTab;
